<script>
  // about
  import Footer from '../components/Footer.svelte'
  import Menu from '../components/Menu.svelte'
</script>

<div class="wrap">
  <div class="menu-wrap"><Menu /></div>
  <section>
    <p>
      This project attempted to piece together what happened during the period
      of unrest between 8 and 16 July 2021 in KwaZulu-Natal and Gauteng using
      posts shared on social media. To do this we initially collected posts from
      Instagram, YouTube, TikTok, Facebook and Twitter, which we used to create
      a timeline of events.
    </p>

    <p>
      The timeline contained more than 550 posts, far too many to include in one
      story, but it helped us to organise what happened, where it happened and
      when it happened. From this we created an animated map of places that were
      affected during the period.
    </p>

    <p>
      Many of the posts contained videos or photographs which were useful to
      help verify where some of the events happened and give a better idea of
      what happened.
    </p>

    <p>
      It was beyond the scope of this project to write about all the events, and
      much of what happened has already been described by the media.
    </p>

    <p>
      We were also limited to social media platforms that are open to the
      public, which means we were not able to collect posts from WhatsApp,
      Telegram or Signal groups.
    </p>

    <p>
      It is relatively easy to bulk download tweets that include specific
      hashtags so we decided to use this to help us focus the story on
      particular hashtags that were commonly used between 8 and 16 July.
    </p>

    <p>
      We used the <a
        href="https://weverify.eu/verification-plugin/"
        target="_blank">InVID verification plugin's</a
      > network analysis tool to determine the most commonly used hashtags and chose
      four to focus on as themes for the narrative: #FreeJacobZuma, #KZNShutdown,
      #GautengShutdown and #PhoenixMassacre.
    </p>

    <p>InVID was also the source of inspiration for the heatmaps we created.</p>

    <p>
      We used a sample of around 40,000 tweets, which included some additional
      hashtags, such as #RamaphosaMustFall, #JacobZuma, #shutdownKZN and
      #shutdownGauteng, to create a bubble chart to show the extent of activity
      on twitter during the unrest period, which tweets were amplified the most
      by being retweeted the most, and to allow readers to explore the tweets.
    </p>

    <p>
      We were able to filter the tweets to find when hashtags were first used,
      how and by whom. We were also able to filter the users to show which ones
      posted the most tweets using our target hashtags and which user's tweets
      were the most amplified.
    </p>

    <p>
      The narrative aims to pull the themes together and provide context. The
      testimonies of people at the South African Human Rights Commission
      KwaZulu-Natal hearings into the unrest that took place during November and
      early December helped to shape some of the narrative, particularly what
      happened in Phoenix.
    </p>

    <p>
      We would like to thank the Henry Nxumalo Fund for providing a grant that
      allowed us to take the time needed to collect and organise the data on
      which this project is based.
    </p>
  </section>
  <Footer />
</div>

<style>
  .wrap {
    /* margin-top: 100px; */
    background: #1a1a1a;
    min-height: 100vh;
    padding-top: 0px;
  }
  .menu-wrap {
    width: 100%;

    text-align: center;
  }
</style>
